import { render } from "./ScpmSubTitle.vue?vue&type=template&id=09cb48f7&scoped=true"
import script from "./ScpmSubTitle.vue?vue&type=script&lang=js"
export * from "./ScpmSubTitle.vue?vue&type=script&lang=js"

import "./ScpmSubTitle.vue?vue&type=style&index=0&id=09cb48f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cb48f7"],['__file',"src/components/scpm/common/ScpmSubTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09cb48f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09cb48f7', __exports__)) {
    api.reload('09cb48f7', __exports__)
  }
  
  module.hot.accept("./ScpmSubTitle.vue?vue&type=template&id=09cb48f7&scoped=true", () => {
    api.rerender('09cb48f7', render)
  })

}


export default __exports__